import { useEffect, useRef, useState } from 'react';
import type Hls from 'hls.js';

export function ContentVideo({ src, poster }: { src: string; poster?: string }) {
  const ref = useRef<HTMLVideoElement>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    const video = ref.current;
    if (!video) return;
    setFailed(false);
    let hls: Hls | undefined;
    let cancelled = false;
    if (new URL(src, window.location.href).pathname.endsWith('.m3u8') && !video.canPlayType('application/vnd.apple.mpegurl')) {
      void import('hls.js').then(({ default: Hls }) => {
        if (cancelled) return;
        if (!Hls.isSupported()) { setFailed(true); return; }
        hls = new Hls({ maxBufferLength: 10, maxMaxBufferLength: 20 });
        hls.on(Hls.Events.ERROR, (_, data) => { if (data.fatal) setFailed(true); });
        hls.loadSource(src);
        hls.attachMedia(video);
      }).catch(() => { if (!cancelled) setFailed(true); });
    } else video.src = src;
    return () => { cancelled = true; hls?.destroy(); video.removeAttribute('src'); video.load(); };
  }, [src]);
  return <><video ref={ref} poster={poster} controls playsInline preload="metadata" onError={() => setFailed(true)} />{failed && <p role="status">โหลดคลิปไม่ได้ กรุณาลองเปิดหน้านี้อีกครั้ง</p>}</>;
}
